import { ConcreteException } from '../base.js';
export class TurnkeyWalletSessionException extends ConcreteException {
    static errorClass = 'TurnkeyWalletSessionException';
    parse() {
        this.setName(TurnkeyWalletSessionException.errorClass);
    }
}
